import React from 'react';
const Header: React.FunctionComponent<{}> = () => {
  return (
    <div>
      <div className="container section" id='Section5'>
        <div className='section-title'>
          Conclusion
        </div>
        <div className='content'>
          Air pollution might be one of the biggest threats that India is facing right now. It not only destroys the environment, but also damages the health and economoy of the country. It is one of the topics which does not get the attention it deserves in Indian media or political discussions. 
          <br />
          <br />
          In January 2019, the central government did launch a <a href="https://pib.gov.in/PressReleseDetail.aspx?PRID=1559384" rel="noopener noreferrer" target="_blank">National Clean Air Program (NCAP)</a> providing a roadmap to prevent, control, and reduce air pollution. This is a much-needed start that needs to be done to clean the air in India; but a lot more effort is required from both the government and civil society. India also has some laws and regulations to control air pollution (like the laws discouraging burning of stubble which causes a lot of pollution in North India), but they are either not very strong or are not enforced. 
          <br />
          <br />
          Aseem Prakash, founding director of the Center for Environmental Politics at the University of Washington, while talking to Vox about the pollution problem in Delhi said <span className="italics">“the problem can be solved, but what you need is political will and a bit of imagination”</span> [<a href="https://www.vox.com/science-and-health/2019/11/8/20948348/delhi-india-air-pollution-quality-cause" rel="noopener noreferrer" target="_blank">source here</a>]. 
          <br />
          <br />
          <span className="bold">India cannot afford to delay action on air pollution as it is costing us both life and money.</span>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

export default Header;